import type { NewsItem } from '../types/news.types'

/**
 * 기사를 실은 곳의 표기 — `originallink`의 호스트를 먼저 쓴다.
 *
 * `link`는 대개 `news.naver.com`이라 그 호스트는 취재한 언론사가 아니라 **중개자**를
 * 가리킨다. 서버 렌더 공개 페이지는 P3-12에서 이미 `originallink` 기준으로 바꿨는데
 * (`backend/app/api/clip_page.py`의 `source_host()`), 정작 사람이 보는 카드는 그대로여서
 * 같은 기사가 화면마다 다른 출처로 보였다. 규칙을 서버와 맞춘다 — `www.` 제거까지.
 *
 * 검색 API는 언론사명 필드를 주지 않는다 (`title`·`originallink`·`link`·`description`·
 * `pubDate`가 전부). 호스트가 응답으로 낼 수 있는 가장 구체적인 출처다.
 *
 * 표기 규칙의 원본이 서버와 여기 둘이다 — 한쪽만 고치면 또 갈린다.
 */
export function sourceHost(item: Pick<NewsItem, 'link' | 'originallink'>): string {
  try {
    return new URL(item.originallink || item.link).hostname.replace(/^www\./, '')
  } catch {
    return '네이버 뉴스'
  }
}

/** "원문 보기"가 가리킬 곳. 예전 클리핑은 `originallink`가 없어 `link`로 폴백한다. */
export function originalUrl(item: Pick<NewsItem, 'link' | 'originallink'>): string {
  return item.originallink || item.link
}
